import { tracked } from '@glimmer/tracking';

import type { GeneralComponentClass } from 'webapp-types';

// export enum Layout {
// 	GENERAL = 'general',
// 	STATUS_OBJECTS = 'status-objects',
// 	REPORT_PDF = 'report-pdf',
// 	VIEW_DIGEST = 'view-digest',
// 	VIEW_BOARD = 'view-board',
// 	FEEDBACK = 'feedback',
// 	DATA_EXPORT = 'data-export',
// }

export type onCloseFn = (item: InfolayerItemBase) => void;

// export type ValidComponentName = `infolayer/type-${Layout}`;

export interface ConstructorData {
	id: string | number;
}

export const EXPIRE_ERROR = 8000;
export const EXPIRE_OK = 5000;
export const EXPIRE_WARNING = 5000;
export const EXPIRE_INFO = 5000;
export const EXPIRE_PROGRESS = 30000;

export default abstract class InfolayerItemBase {
	// abstract layout: Layout;

	abstract componentClass: GeneralComponentClass;

	@tracked visible = true;
	@tracked hidden = false;

	id: number | string;
	timeout: ReturnType<typeof setTimeout> | null = null;
	expireTime: number | null = null;
	preventClose = false;
	onClose: onCloseFn;

	constructor(data: ConstructorData, onClose: onCloseFn) {
		this.id = data.id;
		this.onClose = onClose;
	}

	get classes(): string {
		return this.hidden ? 'hidden' : this.visible ? 'visible' : '';
	}

	// get componentName(): ValidComponentName {
	// 	return `infolayer/type-${this.layout}`;
	// }

	abstract checkIfDuplicated(items: InfolayerItemBase[]): boolean;

	expire(time?: number | null): void {
		// clear timeout if it is set
		if (this.timeout) {
			clearTimeout(this.timeout);
		}

		this.expireTime = time ?? null;

		if (!time) {
			return;
		}

		this.timeout = setTimeout(
			() => {
				this.close();
			},
			time ? time : 8000,
		);
	}

	// stops the countdown while the user hovers the toast; resumeExpiry() starts it again in full
	pauseExpiry(): void {
		if (this.timeout) {
			clearTimeout(this.timeout);
			this.timeout = null;
		}
	}

	resumeExpiry(): void {
		if (!this.hidden) {
			this.expire(this.expireTime);
		}
	}

	close(): void {
		this.visible = false;
		this.hidden = true;
		this.onClose(this);
	}
}
